import HistoryImportPage from "@/pages/HistoryImportPage";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ViewModeProvider } from "@/context/ViewModeContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { AgentProvider } from "@/context/AgentContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import SessionGuard from "@/components/SessionGuard";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import AlertsPage from "@/pages/AlertsPage";
import ReportsPage from "@/pages/ReportsPage";
import SpeedDrivingPage from "@/pages/SpeedDrivingPage";
import AdminPage from "@/pages/AdminPage";
import AdminPartnerPage from "@/pages/AdminPartnerPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import SharePage from "@/pages/SharePage";
import InterventionPage from "@/pages/InterventionPage";
import RouteTemplatesPage from "@/pages/RouteTemplatesPage";
import InterventionsPage from "@/pages/InterventionsPage";
import TicketsPage from "@/pages/TicketsPage";
import GlobalHistoryPage from "@/pages/GlobalHistoryPage";
import MaintenancePage from "@/pages/MaintenancePage";
import SettingsPage from "@/pages/SettingsPage";
import DemoAccess from "@/pages/DemoAccess";
import AssistantBoomerang from "@/components/AssistantBoomerang";

// Assistant Boomerang désactivé (flag OFF). Remettre à true pour réactiver le widget flottant.
const ASSISTANT_BOOMERANG_ENABLED = false;

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ViewModeProvider>
          <SettingsProvider>
          <AgentProvider>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/historique" element={<ProtectedRoute feature="history"><GlobalHistoryPage /></ProtectedRoute>} />
            <Route path="/alertes" element={<ProtectedRoute feature="history"><AlertsPage /></ProtectedRoute>} />
            <Route path="/maintenance" element={<ProtectedRoute><MaintenancePage /></ProtectedRoute>} />
            <Route path="/rapports" element={<ProtectedRoute feature="reports"><ReportsPage /></ProtectedRoute>} />
            <Route path="/rapports/vitesse" element={<ProtectedRoute feature="reports"><SpeedDrivingPage /></ProtectedRoute>} />
            <Route path="/tickets" element={<ProtectedRoute feature="tickets"><TicketsPage /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute feature="admin"><AdminPage /></ProtectedRoute>} />
            <Route path="/partenaire" element={<ProtectedRoute adminOnly><AdminPartnerPage /></ProtectedRoute>} />
            <Route path="/analytique" element={<ProtectedRoute feature="reports"><AnalyticsPage /></ProtectedRoute>} />
            <Route path="/trajets-types" element={<ProtectedRoute feature="reports"><RouteTemplatesPage /></ProtectedRoute>} />
            <Route path="/interventions" element={<ProtectedRoute feature="interventions" viewRoles={["client"]}><InterventionsPage /></ProtectedRoute>} />
            <Route path="/parametres" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
            <Route path="/share/:token" element={<SharePage />} />
            <Route path="/demo/:token" element={<DemoAccess />} />
            <Route path="/intervention/:token" element={<InterventionPage />} />
            <Route path="/import-historique" element={<ProtectedRoute adminOnly><HistoryImportPage /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Toaster position="top-right" theme="dark" richColors />
          <SessionGuard />
          {/* Assistant Boomerang désactivé (flag OFF) — masqué côté UI. Aucune donnée supprimée. */}
          {ASSISTANT_BOOMERANG_ENABLED && <AssistantBoomerang />}
          </AgentProvider>
          </SettingsProvider>
          </ViewModeProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
